var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 6.73175C20.3377 7.02575 19.626 7.22375 18.879 7.313C19.6418 6.85625 20.2275 6.1325 20.5027 5.27C19.7895 5.693 18.999 6.0005 18.1575 6.16625C17.4847 5.4485 16.524 5 15.462 5C13.0777 5 11.3258 7.2245 11.8643 9.53375C8.796 9.38 6.075 7.91 4.25325 5.67575C3.28575 7.3355 3.7515 9.50675 5.3955 10.6062C4.791 10.5867 4.221 10.421 3.72375 10.1443C3.68325 11.855 4.9095 13.4555 6.6855 13.8117C6.16575 13.9527 5.5965 13.9858 5.0175 13.8748C5.487 15.3418 6.8505 16.409 8.4675 16.439C6.915 17.6562 4.959 18.2 3 17.969C4.63425 19.0168 6.576 19.628 8.661 19.628C15.5175 19.628 19.3912 13.8372 19.1572 8.6435C19.8787 8.12225 20.505 7.472 21 6.73175V6.73175Z",
    fill: "rgba(255, 255, 255, 0.5)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.5641341d.svg";
export { ForwardRef as ReactComponent };